var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:({ width: _vm.progress + '%' })}),_c('div',{staticClass:"progress-text"},[_vm._v(_vm._s(_vm.progress.toFixed(0))+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }